var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
var initFormData = {
    order_types: '',
    keywords: ''
};
var TYPE_LIST = [
    {
        id: 5,
        name: '报价冻结'
    },
    {
        id: 6,
        name: '报价扣款'
    },
    {
        id: 7,
        name: '报价解冻'
    },
    {
        id: 3,
        name: '充值'
    },
    {
        id: 4,
        name: '赠送'
    }
];
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.typeList = TYPE_LIST;
        return _this;
    }
    BillHeader.prototype.search = function () {
        var filter = __assign({}, this.formData);
        filter.order_types = filter.order_types && filter.order_types.join(',');
        this.$emit('search', filter);
    };
    BillHeader.prototype.reset = function () {
        this.formData = __assign({}, initFormData);
    };
    BillHeader = __decorate([
        Component
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
